import { muiTheme } from "@/styles/theme";
import { Button, styled } from "@mui/material";

export const TextButton = styled(Button)({
  textTransform: "none",
  fontSize: "12px",
  fontWeight: 600,
  color: muiTheme.colorSchemes.light.palette.primary[500],
  "&:hover": {
    backgroundColor: "transparent",
  },
});
